import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
@Component({})
export default class progressLine extends Vue {
  @Prop({ default: "sisas" })
  color: string;
}
